import { Line } from '@react-three/drei';
import { toVec3 } from '@slope/three';
import { useMemo } from 'react';
import * as THREE from 'three';

interface ParabolicLineProps {
  startPoint: THREE.Vector3 | THREE.Vector3Tuple;
  endPoint: THREE.Vector3 | THREE.Vector3Tuple;
}

// Función utilitaria para calcular los puntos de la parábola
const calculateParabolicPoints = (
  start: THREE.Vector3,
  end: THREE.Vector3,
  numPoints: number = 25,
): [number, number, number][] => {
  const points: [number, number, number][] = [];
  const dx = end.x - start.x;
  const dz = end.z - start.z;

  // Calcular la distancia total en el plano XZ
  const distance = Math.sqrt(dx * dx + dz * dz);

  // Definir una altura máxima proporcional a la distancia
  const maxHeight = distance * 0.5; // Por ejemplo, 0.5 veces la distancia

  for (let i = 0; i <= numPoints; i++) {
    const t = i / numPoints;
    const x = start.x + t * dx;
    const z = start.z + t * dz;

    // Interpolación cuadrática para el eje Y (vertical)
    const y = (1 - t) ** 2 * start.y + 2 * (1 - t) * t * (start.y + maxHeight) + t ** 2 * end.y;

    points.push([x, y, z]);
  }
  return points;
};

const v1 = new THREE.Vector3();
const v2 = new THREE.Vector3();

export const ParabolicLine: React.FC<ParabolicLineProps> = ({ startPoint, endPoint }) => {
  const points = useMemo(() => {
    return calculateParabolicPoints(toVec3(startPoint, v1), toVec3(endPoint, v2));
  }, [startPoint, endPoint]);

  return <Line points={points} color="orange" lineWidth={2} />;
};
